import { AxiosError } from 'axios';
import { PUT_AMEND_SUBMIT_REQUEST_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutAmendSubmitRequest = ({ uuid, onSuccess, onError }: Input) => {
  const putAmendSubmitRequest = async () => {
    await axiosClient.put(PUT_AMEND_SUBMIT_REQUEST_URL(uuid));
  };

  return useCustomMutation(putAmendSubmitRequest, {
    onSuccess,
    onError,
  });
};
